import apiClient from '@/services/axios'
import { notification } from 'ant-design-vue'
import { getErrorMessage } from '@/views/apps/fortune-wheel/composables/useGetErrorMessage.js'

const referralApiUrl = process.env.VUE_APP_REFERRAl_API_URL

const addSingleMember = async (context, programId, role, payload) => {
  try {
    context.loading = true

    const url = `${referralApiUrl}/referral-programs/${programId}/members/${role}/add`
    const response = await apiClient.post(url, payload)
    const { data } = response?.data
    if (data) {
      return data
    }
    getErrorMessage(response?.data)
    return null
  } catch (e) {
    notification.error({
      message: e?.message ? e.message : 'Error',
    })
  } finally {
    context.loading = false
  }
}

export { addSingleMember }
